import React from 'react';
import PropTypes from 'prop-types';

import { TranslatorComponent_Text as Translator } from 'ggApp/modules/translator';

import { Link } from './styled';

const PageLink = ({ className, pageLinkTo, pageLinkTk, external, type, id, target, onClick }) => (
    <Link
        className={className}
        key={pageLinkTo}
        external={external}
        to={pageLinkTo}
        type={type}
        id={id}
        target={target}
        onClick={onClick}
    >
        <Translator tk={pageLinkTk} />
    </Link>
);

PageLink.propTypes = {
    className: PropTypes.string,
    pageLinkTo: PropTypes.string,
    pageLinkTk: PropTypes.string,
    external: PropTypes.bool,
    type: PropTypes.string,
    id: PropTypes.string,
    target: PropTypes.string,
};

PageLink.defaultProps = {
    className: '',
    pageLinkTo: '',
    pageLinkTk: '',
    external: false,
    type: 'catalog-link',
    id: null,
    target: undefined,
};

export default PageLink;
